import React from 'react';
import ReactDom from 'react-dom';
import { Button, Image, Typography } from 'lib/components';
import classes from './index.module.scss';

/**
 * Props interface for the VoidReasonModal component
 */
interface Props {
	/** Whether the modal is currently open */
	isOpen: boolean;
	/** Reason text for voiding the invoice item */
	reason?: string;
	/** Callback function when the modal is closed */
	onClose: () => any;
}

/**
 * VoidReasonModal component
 * Displays a modal with the reason for voiding an invoice item
 * Used in the invoice detail view to show void justification
 *
 * @param {Props} props - Component props
 * @returns {JSX.Element | null} - Rendered component or null if not open
 */
const VoidReasonModal = ({ isOpen, onClose, reason }: Props) => {
	// Don't render anything if the modal is closed
	if (!isOpen) {
		return null;
	}

	// Render the modal using a portal to ensure it appears above other content
	return ReactDom.createPortal(
		<div className={classes['modal']}>
			<div className={classes['modal-content']}>
				<div className={classes['modal-items']}>
					<div>
						{/* Modal title with warning icon */}
						<div className={classes['modal-title']}>
							<Image src="icDangerAlertPrimary" />
							<Typography variant="subheading1" weight="bold">
								Reasoning for Voiding Item:
							</Typography>
						</div>
						{/* Void reason text */}
						<Typography>{reason}</Typography>
					</div>
					{/* Footer with close button */}
					<div className={classes['modal-unvoid-footer']}>
						<Button
							style={{
								justifyContent: 'center',
							}}
							variant="standard"
							color="gray"
							sizing="small"
							title="Close"
							onClick={onClose}
						/>
					</div>
				</div>
			</div>
		</div>,
		// Mount the portal in the designated element in the DOM
		document.getElementById('portal') as HTMLElement
	);
};

export default VoidReasonModal;
